import { createSelector } from "@reduxjs/toolkit";

export const getSomDbTableData = (state) => state.somDb.tableData;
export const getSomDbColumnsData = (state) => state.somDb.columnsData;
export const getSomDbInitColumns = (state) => state.somDb.initColumns;
export const getExpandedSomItemChars = (state) => state.somDb.expandedSomItemChars;
export const getExpandedSomItemSuppliers = (state) => state.somDb.expandedSomItemSuppliers;
export const getExpandedSomItemFilter = (state) => state.somDb.expandedSomItemFilter;
export const getExpandedSomItemProjectDocs = (state) => state.somDb.expandedSomItemProjectDocs;

export const getSelectedSomDbViewMode = (state) => state.somDb.selectedViewMode;
export const getSomDbFilterParams = (state) => state.somDb.filterParams;
export const getSomDbFilterRows = (state) => state.somDb.filterRows;
export const getSomDbShouldClearFilter = (state) => state.somDb.shouldClearFilter;
export const getSomDbWithEmptyChars = (state) => state.somDb.withEmptyChars;
export const getSelectedClassifier = (state) => state.somDb.selectedClassifier;
export const getSomDbSelectedStatus = (state) => state.somDb.selectedStatus;
export const getSomDbFetchStatus = (state) => state.somDb.fetchStatus;
export const getSomDbFetchRibbonStatus = (state) => state.somDb.fetchRibbonStatus;
export const getSomDbFetchStatusText = (state) => state.somDb.fetchStatusText;
export const getSomDbStatisticView = (state) => state.somDb.statisticView;

export const getSomDbSelectedColumns = createSelector([getSomDbColumnsData], (columns) => {
	return columns.filter(({ checked }) => checked);
});
